export enum BusinessRegion {
  SouthAfrica = 'ZA',
  UnitedStatesCanada = 'US/CA',
  International = 'International'
}
